import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1248c90c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-style-panel" }
const _hoisted_2 = { class: "preset-style" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("A²")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("A₂")
const _hoisted_8 = { class: "link-popover" }
const _hoisted_9 = { class: "btns" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "行间距：", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "段间距：", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "字间距：", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "首行缩进：", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "文本框填充：", -1))

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTTextElement } from '@/types/slides'
import emitter, { EmitterEvents, RichTextAction } from '@/utils/emitter'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useTextFormatPainter from '@/hooks/useTextFormatPainter'

import { message } from 'ant-design-vue'

import ElementOpacity from '../common/ElementOpacity.vue'
import ElementOutline from '../common/ElementOutline.vue'
import ElementShadow from '../common/ElementShadow.vue'
import ColorButton from '../common/ColorButton.vue'
import TextColorButton from '../common/TextColorButton.vue'

// 注意，存在一个未知原因的BUG，如果文本加粗后文本框高度增加，画布的可视区域定位会出现错误
// 因此在执行预置样式命令时，将加粗命令放在尽可能靠前的位置，避免字号增大后再加粗

export default /*#__PURE__*/_defineComponent({
  __name: 'TextStylePanel',
  setup(__props) {

const presetStyles = [
  {
    label: '大标题',
    style: {
      fontSize: '26px',
      fontWeight: 700,
    },
    cmd: [
      { command: 'clear' },
      { command: 'bold' },
      { command: 'fontsize', value: '48px' },
      { command: 'align', value: 'center' },
    ],
  },
  {
    label: '小标题',
    style: {
      fontSize: '22px',
      fontWeight: 700,
    },
    cmd: [
      { command: 'clear' },
      { command: 'bold' },
      { command: 'fontsize', value: '36px' },
      { command: 'align', value: 'center' },
    ],
  },
  {
    label: '正文',
    style: {
      fontSize: '20px',
    },
    cmd: [
      { command: 'clear' },
      { command: 'fontsize', value: '20px' },
    ],
  },
  {
    label: '正文[小]',
    style: {
      fontSize: '18px',
    },
    cmd: [
      { command: 'clear' },
      { command: 'fontsize', value: '18px' },
    ],
  },
  {
    label: '注释 1',
    style: {
      fontSize: '16px',
      fontStyle: 'italic',
    },
    cmd: [
      { command: 'clear' },
      { command: 'fontsize', value: '16px' },
      { command: 'em' },
    ],
  },
  {
    label: '注释 2',
    style: {
      fontSize: '16px',
      textDecoration: 'underline',
    },
    cmd: [
      { command: 'clear' },
      { command: 'fontsize', value: '16px' },
      { command: 'underline' },
    ],
  },
]

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId, richTextAttrs, availableFonts, textFormatPainter } = storeToRefs(mainStore)

const { addHistorySnapshot } = useHistorySnapshot()
const { toggleFormatPainter } = useTextFormatPainter()

const updateElement = (props: Partial<PPTTextElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

const fill = ref<string>('#000')
const lineHeight = ref<number>()
const wordSpace = ref<number>()
const textIndent = ref<number>()
const paragraphSpace = ref<number>()

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'text') return

  fill.value = handleElement.value.fill || '#fff'
  lineHeight.value = handleElement.value.lineHeight || 1.5
  wordSpace.value = handleElement.value.wordSpace || 0
  textIndent.value = handleElement.value.textIndent || 0
  paragraphSpace.value = handleElement.value.paragraphSpace === undefined ? 5 : handleElement.value.paragraphSpace
}, { deep: true, immediate: true })

const fontSizeOptions = [
  '12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px',
  '36px', '40px', '44px', '48px', '54px', '60px', '66px', '72px', '76px',
  '80px', '88px', '96px', '104px', '112px', '120px',
]
const lineHeightOptions = [0.9, 1.0, 1.15, 1.2, 1.4, 1.5, 1.8, 2.0, 2.5, 3.0]
const wordSpaceOptions = [0, 1, 2, 3, 4, 5, 6, 8, 10]
const textIndentOptions = [0, 48, 96, 144, 192, 240, 288, 336]
const paragraphSpaceOptions = [0, 5, 10, 15, 20, 25, 30, 40, 50, 80]

// 设置行高
const updateLineHeight = (value: number) => {
  updateElement({ lineHeight: value })
}

// 设置段间距
const updateParagraphSpace = (value: number) => {
  updateElement({ paragraphSpace: value })
}

// 设置字间距
const updateWordSpace = (value: number) => {
  updateElement({ wordSpace: value })
}

// 设置首行缩进
const updateTextIndent = (value: number) => {
  updateElement({ textIndent: value })
}

// 设置文本框填充
const updateFill = (value: string) => {
  updateElement({ fill: value })
}

// 发射富文本设置命令
const emitRichTextCommand = (command: string, value?: string) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command, value } })
}

// 发射富文本设置命令（批量）
const emitBatchRichTextCommand = (action: RichTextAction[]) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action })
}

// 设置富文本超链接
const link = ref('')
const linkPopoverVisible = ref(false)

watch(richTextAttrs, () => linkPopoverVisible.value = false)

const openLinkPopover = () => {
  link.value = richTextAttrs.value.link
  linkPopoverVisible.value = true
}
const updateLink = (link?: string) => {
  if (link) {
    const linkRegExp = /^(https?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/
    if (!linkRegExp.test(link)) return message.error('不是正确的网页链接地址')
  }
  emitRichTextCommand('link', link)
  linkPopoverVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")!
  const _component_Select = _resolveComponent("Select")!
  const _component_IconAddText = _resolveComponent("IconAddText")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_IconTextBold = _resolveComponent("IconTextBold")!
  const _component_CheckboxButton = _resolveComponent("CheckboxButton")!
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")!
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")!
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")!
  const _component_CheckboxButtonGroup = _resolveComponent("CheckboxButtonGroup")!
  const _component_IconCode = _resolveComponent("IconCode")!
  const _component_IconQuote = _resolveComponent("IconQuote")!
  const _component_IconFormat = _resolveComponent("IconFormat")!
  const _component_IconFormatBrush = _resolveComponent("IconFormatBrush")!
  const _component_Input = _resolveComponent("Input")!
  const _component_IconLinkOne = _resolveComponent("IconLinkOne")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_IconList = _resolveComponent("IconList")!
  const _component_IconOrderedList = _resolveComponent("IconOrderedList")!
  const _component_IconIndentLeft = _resolveComponent("IconIndentLeft")!
  const _component_IconIndentRight = _resolveComponent("IconIndentRight")!
  const _component_IconRowHeight = _resolveComponent("IconRowHeight")!
  const _component_IconVerticalSpacingBetweenItems = _resolveComponent("IconVerticalSpacingBetweenItems")!
  const _component_IconFullwidth = _resolveComponent("IconFullwidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presetStyles, (item) => {
        return _createElementVNode("div", {
          class: "preset-style-item",
          key: item.label,
          style: _normalizeStyle(item.style),
          onClick: ($event: any) => (emitBatchRichTextCommand(item.cmd))
        }, _toDisplayString(item.label), 13, _hoisted_3)
      }), 64))
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_InputGroup, {
      compact: "",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Select, {
          style: {"flex":"3"},
          value: _unref(richTextAttrs).fontname,
          onChange: _cache[0] || (_cache[0] = value => emitRichTextCommand('fontname', value as string))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconFontSize)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFonts), (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ fontFamily: font.value })
                      }, _toDisplayString(font.label), 5)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEB_FONTS), (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(font.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_Select, {
          style: {"flex":"2"},
          value: _unref(richTextAttrs).fontsize,
          onChange: _cache[1] || (_cache[1] = value => emitRichTextCommand('fontsize', value as string))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconAddText)
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fontSizeOptions, (fontsize) => {
              return _createVNode(_component_SelectOption, {
                key: fontsize,
                value: fontsize
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(fontsize), 1)
                ]),
                _: 2
              }, 1032, ["value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _unref(richTextAttrs).color,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = value => emitRichTextCommand('color', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字颜色"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).color,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconText)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _unref(richTextAttrs).backcolor,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = value => emitRichTextCommand('backcolor', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字高亮"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).backcolor,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconHighLight)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "增大字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emitRichTextCommand('fontsize-add')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFontSize),
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "减小字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emitRichTextCommand('fontsize-reduce')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFontSize),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "加粗"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).bold,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (emitRichTextCommand('bold')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextBold)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "斜体"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).em,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (emitRichTextCommand('em')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextItalic)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下划线"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).underline,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (emitRichTextCommand('underline')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextUnderline)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "删除线"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).strikethrough,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (emitRichTextCommand('strikethrough')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconStrikethrough)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上标"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).superscript,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (emitRichTextCommand('superscript')))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下标"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).subscript,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (emitRichTextCommand('subscript')))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "行内代码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).code,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (emitRichTextCommand('code')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconCode)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "引用"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).blockquote,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (emitRichTextCommand('blockquote')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconQuote)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "清除格式"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              onClick: _cache[14] || (_cache[14] = ($event: any) => (emitRichTextCommand('clear')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFormat)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "格式刷"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: !!_unref(textFormatPainter),
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(toggleFormatPainter)()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFormatBrush)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "超链接"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Popover, {
              placement: "bottomRight",
              trigger: "click",
              visible: linkPopoverVisible.value,
              "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((linkPopoverVisible).value = $event))
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Input, {
                    value: link.value,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((link).value = $event)),
                    placeholder: "请输入超链接"
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Button, {
                      size: "small",
                      disabled: !_unref(richTextAttrs).link,
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (updateLink())),
                      style: {"margin-right":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_Button, {
                      size: "small",
                      type: "primary",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (updateLink(link.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CheckboxButton, {
                  style: {"flex":"1"},
                  checked: !!_unref(richTextAttrs).link,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (openLinkPopover()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconLinkOne)
                  ]),
                  _: 1
                }, 8, ["checked"])
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createVNode(_component_RadioGroup, {
      class: "row",
      "button-style": "solid",
      value: _unref(richTextAttrs).align,
      onChange: _cache[21] || (_cache[21] = e => emitRichTextCommand('align', e.target.value))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "left",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "居中"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "center",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextCenter)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "right",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "项目符号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).bulletList,
              onClick: _cache[22] || (_cache[22] = ($event: any) => (emitRichTextCommand('bulletList')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconList)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "编号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).orderedList,
              onClick: _cache[23] || (_cache[23] = ($event: any) => (emitRichTextCommand('orderedList')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconOrderedList)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "减小缩进"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[24] || (_cache[24] = ($event: any) => (emitRichTextCommand('indent', '-1')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconIndentLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "增大缩进"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[25] || (_cache[25] = ($event: any) => (emitRichTextCommand('indent', '+1')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconIndentRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: lineHeight.value,
        onChange: _cache[26] || (_cache[26] = value => updateLineHeight(value as number))
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_IconRowHeight)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(lineHeightOptions, (item) => {
            return _createVNode(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item) + "倍", 1)
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: paragraphSpace.value,
        onChange: _cache[27] || (_cache[27] = value => updateParagraphSpace(value as number))
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_IconVerticalSpacingBetweenItems)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paragraphSpaceOptions, (item) => {
            return _createVNode(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item) + "px", 1)
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: wordSpace.value,
        onChange: _cache[28] || (_cache[28] = value => updateWordSpace(value as number))
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_IconFullwidth)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wordSpaceOptions, (item) => {
            return _createVNode(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item) + "px", 1)
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: textIndent.value,
        onChange: _cache[29] || (_cache[29] = value => updateTextIndent(value as number))
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_IconIndentRight)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(textIndentOptions, (item) => {
            return _createVNode(_component_SelectOption, {
              key: item,
              value: item
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item) + "px", 1)
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: fill.value,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = value => updateFill(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: fill.value,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    _createVNode(ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(ElementShadow),
    _createVNode(_component_Divider),
    _createVNode(ElementOpacity)
  ]))
}
}

})